import React, { useEffect } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { useTranslation } from "react-i18next";
import {ReactComponent as CardImg} from "../../assets/images/card.svg";
import orderStore from "../../stores/order";
import { useNavigate } from "react-router";
import { PaymentMethod } from "../../@types/enums/PaymentType";
import EnterInternalCard from "../../components/EnterInternalCard";
import { hideLoader, showLoader } from "../../helpers/ComponentHelper";
import { observer } from "mobx-react";
import { OrderStatus } from "../../@types/enums/OrderStatus";
import {addToLog} from "../../helpers/ApiHelper";
import apiOpen from "../../api/open";

const PaymentPage = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (orderStore.getPaymentMethod()?.type !== PaymentMethod.GIFT_CARD || (orderStore.getPaymentMethod()?.type === PaymentMethod.GIFT_CARD && orderStore.terminalId === "internalCard")) {
            setTimeout(() => {
                waitPaymentStatus();
            }, 1000);
        }
    }, []);

    const waitPaymentStatus = async () => {
        const r = await orderStore.waitPaymentFinish();
        hideLoader();

        await apiOpen.sendLogs(orderStore.order.id);

        if (r) {
            if (orderStore.isFullyPaid)
                navigate("/receipt");
            else
                navigate("/order");
        }
        else
            navigate("/order");
    }

    const cancelPayment = async () => {
        addToLog(`Click on cancel payment`);

        if (orderStore.getPaymentMethod()?.type !== PaymentMethod.GIFT_CARD) {
            showLoader();
            const r = await orderStore.cancelPayment();
            if (!r) {
                addToLog(`Payment was canceled by user`);
                hideLoader();
            }
        }
        else {
            navigate("/order");
        }
    }

    const startPayment = async () => {
        showLoader();
        const r = await orderStore.startPayment();
        if (r) {
            addToLog(`Waiting payment approve for #${orderStore.paymentId}`);
            waitPaymentStatus();
        }
        else {
            hideLoader();
            if (orderStore.order.status !== OrderStatus.PART_PAYMENT)
                navigate("/paymentMethod");
        }
    }

    return <div className="PaymentPage">
        <Header />
        <div className="payment">
            {orderStore.getPaymentMethod()?.type === PaymentMethod.CARD
                ? <>
                    <h2>{t("insertCard")}</h2>
                    <div className="card">
                        <CardImg />
                    </div>
                    <div className="button fullWidth mt50" onClick={cancelPayment}>{t("cancel")}</div>
                </>
                : null
            }
            {orderStore.getPaymentMethod()?.type === PaymentMethod.SWISH || orderStore.getPaymentMethod()?.type === PaymentMethod.VIPPS
                ? <>
                    <h2>{t("scanQRCodeToPay")}</h2>
                    <div className="qr">
                        <img className="qrImg" src={`data:image/jpeg;base64,${orderStore.qr}`} alt="QR code" />
                    </div>
                    <div className="button fullWidth mt50" onClick={cancelPayment}>{t("cancel")}</div>
                </>
                : null
            }
            {orderStore.getPaymentMethod()?.type === PaymentMethod.GIFT_CARD && orderStore.terminalId !== "internalCard"
                ? <>
                    <EnterInternalCard goNext={startPayment} />
                    <div className="buttons">
                        <div className="button fullWidth" onClick={cancelPayment}>{t("cancel")}</div>
                        <div className={`button dark fullWidth ${orderStore.internalCard.length ? "" : "disable"}`} onClick={() => {if (orderStore.internalCard.length) startPayment();}}>{t("finalize")}</div>
                    </div>
                </>
                : null
            }

        </div>
    </div>
}

export default observer(PaymentPage);
